module.exports = __webpack_public_path__ + "img/p30000.7206afdf.png";